import { render, staticRenderFns } from "./collectButton.vue?vue&type=template&id=c115c35a&scoped=true&"
import script from "./collectButton.vue?vue&type=script&lang=js&"
export * from "./collectButton.vue?vue&type=script&lang=js&"
import style0 from "./collectButton.vue?vue&type=style&index=0&id=c115c35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c115c35a",
  null
  
)

export default component.exports